import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { faCircleX } from '@fortawesome/pro-light-svg-icons/faCircleX';
import { Icon } from '../icon';
export function ValidationError({ message }) {
    if (!message) {
        return null;
    }
    return (_jsxs("span", { className: "mt-2 flex items-center gap-2", children: [_jsx(Icon, { icon: faCircleX, className: "text-danger-500" }), _jsx("p", { className: "text-extrasmall text-danger-500", children: message })] }));
}
